import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'

export const agentGarageSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    constructionYear: validationRules.constructionYear,
    constructionLastModernization: validationRules.constructionLastModernization,
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  otherFacilities: {
    heightGarage: validationRules.heightGarage,
    widthGarage: validationRules.widthGarage,
    lengthGarage: validationRules.lengthGarage,
    usableArea: validationRules.usableGarageArea,
  },
  objectNumbers: {
    groupNumber: validationRules.groupNumber,
  },
  apiSearchData: defaultApiSearchData,
}
